// extracted by mini-css-extract-plugin
export default {"input":"TextInput_input__JYyo8"};